define(["knockout", "@modules/tools/urlParameters", "@modules/content/enrollment/pcpToEnrollmentFormService", "querystring"], function (ko, urlParameters, PcpToEnrollmentService, querystring) {
    function isAllowedKeyCodesForZipcode(event) {
        // Allow: backspace, delete, tab, escape, and enter
        return event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 27 || event.keyCode === 13 || (event.keyCode === 65 && event.ctrlKey === true) || (event.keyCode >= 35 && event.keyCode <= 39);
    }

    function cleanupUrl(baseUrl, queryObject) {
        return baseUrl + "?" + querystring.stringify(urlParameters.reduceParams(queryObject, {}));
    }

    // PcpToEnrollmentViewModel ctor
    return function (planFinderZipcode, planFinderPlan, planFinderCounty, planFinderState, providerid, providername, groupname, groupnumber, addresssuffix, planFinderYear, planFinderUrl, years, contextLanguage, defaultCountyText, defaultPlanText, contextOEBrokerDataDocumentId, isMarketingPlanPeriod) {
        var self = this;

        self.planFinderResults = {
            zipCode: planFinderZipcode,
            plan: planFinderPlan,
            county: planFinderCounty,
            year: planFinderYear,
            brokerDocumentId: contextOEBrokerDataDocumentId,
            providerid: providerid,
            providername: providername,
            groupname: groupname,
            groupnumber: groupnumber,
            addresssuffix: addresssuffix
        };

        self.languageContext = ko.observable(contextLanguage);
        self.oEBrokerDataDocumentId = ko.observable(contextOEBrokerDataDocumentId);
        self.isMarketingPlanPeriod = ko.observable(isMarketingPlanPeriod);

        self.years = ko.observable(years);
        self.selectedYear = ko.observable(self.planFinderResults.year || "");

        self.showYearsDropdown = ko.computed(function () {
            return self.years().length > 1;
        });

        // should be knockout-ized, no?
        $("#onlineEnrollmentYear").on("change", function () {
            self.selectedYear($("#onlineEnrollmentYear").val());
            if (self.isValidZipcode()) {
                self.getCounties();
                self.getPlans();
            } else {
                defaultCountyOptions();
            }
        });

        self.enrollmentZipcode = ko.observable(self.planFinderResults.zipCode || "");
        self.enrollmentZipcodeCharIsNumeric = function (data, event) {
            if ((event.shiftKey || ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105))) && !isAllowedKeyCodesForZipcode(event)) {
                event.preventDefault();
            }

            return true;
        };

        self.unsupportedZipcode = ko.observable(false);
        self.unexpectedError = ko.observable(false);
        self.onlineEnrollmentNotAvailable = ko.observable(false);

        self.selectedCounty = ko.observable(self.planFinderResults.county || "");

        var defaultCountyOption = {
            Text: defaultCountyText,
            Value: ""
        };
        self.counties = ko.observableArray([defaultCountyOption]);

        self.selectedCounty.subscribe(function (val) {
            if (val == '') {
                val = self.planFinderResults.county;
            }
            if (val && self.enrollmentZipcode().length == 5) {
                self.getPlans();
            }
        });

        self.selectedPlan = ko.observable(self.planFinderResults.plan || "");
        self.selectedPlanDetailUrl = ko.observable("");

        self.selectedPlan.subscribe(function (val) {
            self.unexpectedError(false);
        });

        self.plans = ko.observableArray();

        self.enrollmentZipcode.subscribe(function (val) {
            if (self.isValidZipcode()) {
                self.getCounties();
            } else {
                defaultCountyOptions();
            }
        });

        self.isValidZipcode = function () {
            return validateZipCode(self.enrollmentZipcode());
        };

        self.showCountyDropdown = ko.computed(function () {
            return (
                self.counties().filter(function (obj) {
                    return obj.Value !== "";
                }).length > 1
            );
        });

        self.inputIsValid = ko.computed(function () {
            return validateInputData(self.selectedPlan(), self.selectedCounty(), self.enrollmentZipcode(), self.selectedYear());
        });

        self.isEnrollmentButtonDisabled = ko.computed(function () {
            if (isOnlineEnrollmentAvailable()) {
                return !self.inputIsValid();
            } else {
                return true;
            }
        });

        self.isPlanDropdownDisabled = ko.computed(function () {
            return !self.isValidZipcode() || self.unsupportedZipcode() || !self.selectedCounty() || self.onlineEnrollmentNotAvailable();
        });

        function defaultCountyOptions() {
            self.counties([defaultCountyOption]);
            self.selectedCounty("");
        }

        function validateZipCode(zipcodeData) {
            var zipcodeString = zipcodeData.toString();
            return zipcodeString.length === 5;
        }

        function isOnlineEnrollmentAvailable() {
            if (window.scan.aepYears.length === 1) {
                result = true;
            } else if (window.scan.aepYears[1] !== self.selectedYear()) {
                result = true;
            } else {
                result = self.isMarketingPlanPeriod() !== "True";
            }
            return result;
        }

        function validateInputData(planData, countyData, zipcodeData, yearData) {
            return planData && countyData && validateZipCode(zipcodeData) && yearData;
        }

        self.isLoadingCounties = ko.observable(false);
        self.isLoadingPlans = ko.observable(false);
        self.isSubmitting = ko.observable(false);
        self.isLoading = ko.computed(function () {
            return self.isLoadingCounties() || self.isLoadingPlans() || self.isSubmitting();
        });

        function setupCountyDropdown(counties) {
            self.counties([defaultCountyOption].concat(counties));
            if (counties.length === 1) {
                self.selectedCounty(counties[0].Value);
                self.plans();
            } else if (counties.length === 0) {
                self.unsupportedZipcode(true);
                self.plans([]);
            }
        }

        function setupRetrieveCountyFailure() {
            self.unexpectedError(true);
            self.isLoadingCounties(false);
        }

        self.getCounties = function () {
            self.unsupportedZipcode(false);
            self.unexpectedError(false);
            self.onlineEnrollmentNotAvailable(false);

            if (!self.isValidZipcode()) {
                console.log("Zipcode is invalid to submit.");
                return;
            }
            if (!isOnlineEnrollmentAvailable()) {
                self.onlineEnrollmentNotAvailable(true);
                return;
            }
            self.isLoadingCounties(true);

            PcpToEnrollmentService.getCounties(self.enrollmentZipcode(), self.selectedYear())
                .done(function (results) {
                    setupCountyDropdown(results);
                    self.isLoadingCounties(false);
                    return true;
                })
                .fail(function () {
                    setupRetrieveCountyFailure();
                });
        };

        function setupPlansDropdown(plans) {
            self.plans(plans);
            if (plans.length === 0) {
                self.unsupportedZipcode(true);
                self.plans([]);
            }
        }

        function setupRetrievePlansFailure() {
            self.unexpectedError(true);
            self.isLoadingPlans(false);
        }

        self.getPlans = function () {
            self.unexpectedError(false);
            self.unsupportedZipcode(false);
            self.isLoadingPlans(true);
            if (self.planFinderResults.county != '' && self.selectedCounty() == '') {
                self.selectedCounty(self.planFinderResults.county);
            }

            PcpToEnrollmentService.getPlans(
                self.selectedCounty(),
                self.enrollmentZipcode,
                self.selectedYear(),
                self.languageContext(),
                planFinderState,
                providerid,
                self.planFinderResults.addresssuffix,
                self.planFinderResults.groupnumber
            )
                .done(function (results) {
                    setupPlansDropdown(results);
                    self.isLoadingPlans(false);
                    if (self.planFinderResults.county != '') {
                        $("#onlineEnrollmentCounty option[value='" + self.selectedCounty() + "']").prop('selected', true);
                    }
                })
                .fail(function () {
                    setupRetrievePlansFailure();
                });
        };

        // self.submit = function () {
        //     // do we need this to be in a submit function if we have no button?
        //     self.unexpectedError(false);
        //     if (!self.inputIsValid()) {
        //         return;
        //     }
        //
        //     self.isSubmitting(true);
        //     var parameters = {
        //         County: self.selectedCounty(),
        //         Zipcode: self.enrollmentZipcode(),
        //         Year: self.selectedYear(),
        //         Language: self.languageContext(),
        //         Plan: self.selectedPlan(),
        //         OEBrokerDataDocumentId: self.oEBrokerDataDocumentId()
        //     };
        //
        //     PcpToEnrollmentService.enroll(parameters)
        //         .done(function (result) {
        //             var dataLayer = window.dataLayer || [];
        //             dataLayer.push({
        //                 event: "continueEnrollment",
        //                 zipCode: self.enrollmentZipcode(),
        //                 county: self.selectedCounty(),
        //                 planYear: self.selectedYear(),
        //                 planName: self.selectedPlan()
        //             });
        //             window.location.href = result.Url;
        //         })
        //         .fail(function (jqXHR, textStatus, errorThrown) {
        //             self.unexpectedError(true);
        //             self.isSubmitting(false);
        //         });
        // };

        self.basePlanFinderLink = ko.observable(planFinderUrl);

        self.planFinderLinkUrl = ko.computed(function () {
            var baseUrl = self.basePlanFinderLink();
            var query = {
                zipCode: self.enrollmentZipcode(),
                county: encodeURIComponent(self.selectedCounty())
            };
            return cleanupUrl(baseUrl, query);
        }, this);

        self.selectPlan = (planObject) => {
            if (self.selectedPlan() !== planObject.Identifier) {
                self.selectedPlan(planObject.Identifier);
                self.selectedPlanDetailUrl(planObject.DetailPageLink.Url);
                $("#continueToOnlineEnrollment").data('planname', planObject.Name);
                $('html, body').animate({
                    scrollTop: $(document).height() - $(window).height()
                });
            } else {
                self.selectedPlan("");
                self.selectedPlanDetailUrl("");
            }
        };

        // This whole section is for if the user came from plan finder, send them directly to A3 without the dialog

        self.loadingPlanFinderResults = ko.observable(false);
        // self.planFinderInformationIsValid = ko.observable(false);

        self.submitPlanFinderResults = function () {
            var parameters = {
                County: self.selectedCounty(),
                Zipcode: self.enrollmentZipcode(),
                Year: self.selectedYear(),
                Language: self.languageContext(),
                Plan: self.planFinderResults.plan !== "" ? self.planFinderResults.plan : self.selectedPlan(),
                OEBrokerDataDocumentId: self.planFinderResults.brokerDocumentId,
                IsOnlineEnrollmentAvailable: isOnlineEnrollmentAvailable(),
                ProviderId: self.planFinderResults.providerid,
                ProviderName: self.planFinderResults.providername,
                GroupName: self.planFinderResults.groupname,
                GroupNumber: self.planFinderResults.groupnumber,
                AddressSuffix: self.planFinderResults.addresssuffix
            };

            self.isSubmitting(true);

            return PcpToEnrollmentService.enroll(parameters);
        };

        //providerid=047252&providername=LEEDS,%20SCOTT%20MITCHELL,%20MD&groupname=PROSPECT%20HEALTH%20SOURCE%20MEDICAL%20GROUP&groupnumber=1028&state=CA&addresssuffix=B&findmypcp=true&zipOrAddress=90210

        // if (validateInputData(self.planFinderResults.plan, self.planFinderResults.county, self.planFinderResults.zipCode, self.planFinderResults.year)) {
        //     self.loadingPlanFinderResults(true);
        //     self.planFinderInformationIsValid(true);
        //     PcpToEnrollmentService.getCounties(self.enrollmentZipcode(), self.selectedYear())
        //         .done(function (countyResults) {
        //             setupCountyDropdown(countyResults);
        //             var county = self.counties().filter(function (obj) {
        //                 return obj.Value === self.planFinderResults.county;
        //             });
        //             if (county[0]) {
        //                 self.selectedCounty(county[0].Value);
        //                 PcpToEnrollmentService.getPlans(self.planFinderResults.county, self.planFinderResults.zipCode, self.planFinderResults.year, self.languageContext(), planFinderState, providerid)
        //                     .done(function (planResults) {
        //                         setupPlansDropdown(planResults);
        //                         var plan = self.plans().filter(function (obj) {
        //                             return obj.Identifier === self.planFinderResults.plan;
        //                         });
        //                         if (plan[0]) {
        //                             self.selectedPlan(plan[0].Identifier);
        //                         } else {
        //                             self.planFinderInformationIsValid(false);
        //                         }
        //                         self.loadingPlanFinderResults(false);
        //                     })
        //                     .fail(function () {
        //                         setupRetrievePlansFailure();
        //                         self.loadingPlanFinderResults(false);
        //                         self.planFinderInformationIsValid(false);
        //                     });
        //             } else {
        //                 self.loadingPlanFinderResults(false);
        //                 self.planFinderInformationIsValid(false);
        //             }
        //         })
        //         .fail(function () {
        //             self.loadingPlanFinderResults(false);
        //             self.planFinderInformationIsValid(false);
        //             setupRetrieveCountyFailure();
        //         });
        // }
    };
});
